<!--
 * @Author: your name
 * @Date: 2020-12-31 10:01:21
 * @LastEditTime: 2021-01-04 17:03:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/Freight/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-12-25 16:12:53
 * @LastEditTime: 2021-01-04 17:02:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/Freight/index.vue
-->
<template>
  <!--运费组件  -->
  <div class="con clearfix" @click="showFright">
    <div class="left font12 font_weight400 colo055 color_select">运费</div>
    <div class="left font12 font_weight400 colo087 color_select">
      <!-- {{ mallretailspu.tradeType !== 0 ? "免运费" : "满88包邮" }} -->
      {{ mallretailspu.freight ? mallretailspu.freight.resume : "" }}
    </div>
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right color_right"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    showFright() {
      this.$emit("showFright");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  padding: 7px 0 6px;
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
  .color_right {
    width: 24px;
  }
}
</style>
